import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';

//import components
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';
import CollectionsMenu from '../components/collections/CollectionsMenu.js';
import Error505Page from '../components/Error505Page.js';
import LoadingIndicator from '../components/LoadingIndicator.js';
import CollectionsAbout from '../components/collections/CollectionsAbout.js';
import CollectionAbout from '../components/collections/CollectionAbout.js';

import withTitle from '../scripts/WithTitle.js';

class Collections extends Component {
    constructor() {
        super();

        this.state = {
        };
    };

    componentDidMount() {
        const { actions, clang, match } = this.props;

        actions.getCollections(clang);

        const isAbout = !match.params.id;

        if (isAbout) {
            actions.getCollectionsAbout(clang);
        } else {
            actions.getCollectionAbout(match.params.id);
        }
    };

    componentDidUpdate(prevProps) {
        const { actions, clang, match, dataAbout, history } = this.props;

        const isAbout = !match.params.id;

        if (clang !== prevProps.clang) {
            actions.getCollections(clang);
        }

        if (clang !== prevProps.clang && isAbout) {
            actions.getCollectionsAbout(clang);
        }

        if (clang !== prevProps.clang && !isAbout && dataAbout && dataAbout.acf && dataAbout.acf.collection_other_language_id) {
            history.push({
                pathname: `/collections/about/${dataAbout.acf.collection_other_language_id}`
            });
        }

        if (!isAbout && match.params.id !== prevProps.match.params.id) {
            actions.getCollectionAbout(match.params.id);
        }
    };

    render() {
        const { clang, match, dataAbout, data, isFetching, isLoadingError, isFetchingAbout, isLoadingErrorAbout } = this.props;

        const isAbout = !match.params.id;
        const breadcrumbsList = isAbout ? [{label: 'home'}, {label: 'collections', link: '/collections'}]
                                        : [{label: 'home'}, {label: 'collections', link: '/collections'}, {label: 'collections-about', link: '/collections/about'}] ;

        if (isFetching) {
            return (
                <section className="collections">
                    <LoadingIndicator />
                </section>
            );
        }

        if (isLoadingError) {
            return (
                <section className="collections">
                    <Error505Page />
                </section>
            );
        }

        if (!data) {
            return null;
        }

        return (
            <section className="collections">
                {isAbout && <ItemBreadcrumbs list={breadcrumbsList} currentPage={lang[clang].collections.about}/>}
                {!isAbout && <ItemBreadcrumbs list={breadcrumbsList} currentPage={dataAbout ? dataAbout.title.rendered : ''}/>}

                <div className="collections__container">
                    <aside className="collections__menu-container">
                        <CollectionsMenu items={data} />
                    </aside>
                    {isAbout &&
                        <CollectionsAbout
                            data={dataAbout}
                            isFetching={isFetchingAbout}
                            isLoadingError={isLoadingErrorAbout}/>}
                    {!isAbout &&
                        <CollectionAbout
                            data={dataAbout}
                            isFetching={isFetchingAbout}
                            isLoadingError={isLoadingErrorAbout}/>}
                </div>
            </section>
        );
    };
};

Collections.propTypes = {
    clang: propTypes.string.isRequired,
    actions: propTypes.object.isRequired,
    dataAbout: propTypes.object,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    dataAbout: state.collectionsAbout.data,
    isFetchingAbout: state.collectionsAbout.isFetching,
    isLoadingErrorAbout: state.collectionsAbout.isLoadingError,
    data: state.collections.data,
    isFetching: state.collections.isFetching,
    isLoadingError: state.collections.isLoadingError,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(Collections);



// WEBPACK FOOTER //
// ./src/containers/Collections.js